module.exports = __webpack_public_path__ + "c2fb2208b9a39ba79319a28285befda9.pdf";